import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Typography,
  Box,
  CardContent,
  Toolbar,
  IconButton,
  Badge,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Tooltip,
  ListItemButton,
  ListItemText,
  List,
  ListSubheader,
  Card,
  CardHeader,
  ListItem,
  CardActions,
  ListItemAvatar,
  Avatar,
  Autocomplete,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";

import { Link, useLocation, useHistory } from "react-router-dom";

import { connect } from "react-redux";
import NoRecordMessage from "../../common/components/NoRecordMessage";

import { approveTraining } from "../../../../store/cpd/actions";

import { getSchoolSubLevelSubjects } from "../../../../store/posts/actions";

import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import ReactPaginate from "react-paginate";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import axios from "axios";
import { showError } from "../../../toastify";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { isEmpty } from "lodash";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import NumberFormat from "react-number-format";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PreviewTrainingDialog = (props) => {
  const {
    loading,
    user,
    approveTraining,
    showDialog,
    setShowDialog,
    training,
  } = props;

  const { hasPermissions } = useRequiredAuth();

  const [trainingTopics, setTrainingTopics] = useState([]);
  const [trainingCohorts, setTrainingCohorts] = useState([]);
  const [trainingMaterials, setTrainingMaterials] = useState([]);

  const [showUploadedDocument, setShowUploadedDocument] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [uploadedDocument, setUploadedDocument] = useState(null);

  const getTrainingTopics = async (trainingId) => {
    try {
      const { data } = await axios.get(
        `/api/cpd/training-topics/${trainingId}`,
      );

      setTrainingTopics(data);
    } catch (error) {}
  };

  const getTrainingCohorts = async (trainingId) => {
    try {
      const { data } = await axios.get(
        `/api/cpd/training-cohorts/${trainingId}`,
      );

      setTrainingCohorts(data);
    } catch (error) {}
  };

  const getTrainingMaterials = async (trainingId) => {
    try {
      const { data } = await axios.get(
        `/api/cpd/training-materials/${trainingId}`,
      );

      setTrainingMaterials(data);
    } catch (error) {}
  };

  useEffect(() => {
    getTrainingTopics(training.id);
    getTrainingCohorts(training.id);
    getTrainingMaterials(training.id);
  }, [training]);

  const onClose = () => setShowDialog(false);

  const [approvals, setApprovals] = useState({
    statusId: "",
    statusComments: "",
  });

  const venueRoomsDefaults = {
    roomName: "",
    numOfTrainees: 0,
    trainers: [],
    errors: {},
  };

  const [venueRooms, setVenueRooms] = useState([{ ...venueRoomsDefaults }]);

  const onSave = (cohortVenue) => {
    if (!formValidator(cohortVenue)) {
      saveTrainingVenueRooms({
        rooms: venueRooms.map((room, index) => ({
          id: cohortVenue.id + `${index}`.padStart(3, "0"),
          trainingCohortVenuesId: cohortVenue.id,
          roomName: room.roomName,
          numOfTrainees: room.numOfTrainees,
          trainers: room.trainers.map((trainer) => trainer.id),
        })),
      });
      // console.log("OK");
    }
  };

  const [errors, setErrors] = useState({
    hasError: false,
  });

  const formValidator = (cohortVenue) => {
    const error = {
      hasError: false,
    };
    const tmpVenueRooms = [...venueRooms];

    let traineesCount = 0;

    tmpVenueRooms?.forEach((room, roomIndex) => {
      traineesCount += +room.numOfTrainees;

      room.errors.roomName = !room.roomName
        ? "Required"
        : tmpVenueRooms.filter(({ roomName }) => roomName === room.roomName)
              .length > 1
          ? "Similar names"
          : undefined;

      room.errors.numOfTrainees = !+room.numOfTrainees
        ? "Required"
        : !!+room.numOfTrainees &&
            +traineesCount !== +cohortVenue.numOfTrainees &&
            roomIndex + 1 === venueRooms.length
          ? "Total trainees must match the venue total"
          : undefined;

      room.errors.trainers = !room.trainers.length ? "Required" : undefined;

      for (const errorKey in room.errors) {
        if (!!room.errors[errorKey]) error.hasError = true;
      }
    });

    setErrors(error);

    if (error.hasError) {
      return true;
    }

    return false;
  };

  const saveTrainingVenueRooms = async (payload) => {
    try {
      setIsLoading(true);
      await axios.post(`/api/cpd/training-venue-rooms`, payload);
      setIsLoading(false);

      // setTrainingMaterials(data);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <Dialog onClose={onClose} open={showDialog} fullWidth maxWidth="xl">
      <DialogTitle className="text-primary">
        {/* <Typography> */}
        <span className="text-primary text-uppercase">
          Preview Training Application
        </span>
        {/* </Typography> */}

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            minHeight: "69vh",
          }}
        >
          <div className="row">
            <div className="col-12">
              <fieldset
                className={`px-3 no-gutters mt-3 form-group border bg-white rounded elevated`}
              >
                <legend
                  className={` w-auto text-primary`}
                  style={{
                    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                    fontWeight: 400,
                    fontSize: "0.82rem",
                    lineHeight: "1em",
                    letterSpacing: "0.00938em",
                  }}
                >
                  Training application
                </legend>

                <div className="row mb-2">
                  <div className="col-8 mt-2">
                    <TextField
                      InputProps={{
                        readOnly: true,
                      }}
                      required
                      size="small"
                      fullWidth
                      name="title"
                      label="Training title"
                      placeholder="Training title"
                      value={training.title || ""}
                    />
                  </div>
                  <div className="mt-2 col-4">
                    <TextField
                      fullWidth
                      size="small"
                      autoComplete="false"
                      name="Provider"
                      label="Provider"
                      placeholder="Provider"
                      variant="outlined"
                      value={training.providerName}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </div>
                  <div className="col-4">
                    <TextField
                      className="mt-3"
                      InputProps={{
                        readOnly: true,
                      }}
                      required
                      size="small"
                      fullWidth
                      name="program"
                      label="CPD Area"
                      placeholder="CPD Area"
                      value={training.programName || ""}
                    />
                  </div>
                  <div className="col-4">
                    <TextField
                      className="mt-3"
                      InputProps={{
                        readOnly: true,
                      }}
                      required
                      size="small"
                      fullWidth
                      name="subProgram"
                      label="Course"
                      placeholder="Course"
                      value={training.subProgramName || ""}
                    />
                  </div>

                  <div className="col-4">
                    <Autocomplete
                      readOnly={true}
                      multiple
                      className="mt-3"
                      size="small"
                      defaultValue={[]}
                      value={trainingTopics}
                      options={[]}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) => option.name}
                      renderOption={(props, option, { selected }) => (
                        <ListItem dense {...props}>
                          <ListItemAvatar>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                          </ListItemAvatar>
                          <ListItemText primary={option.name} />
                        </ListItem>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="topics"
                          label="Modules"
                          placeholder="Modules"
                          inputProps={{
                            ...params.inputProps,
                          }}
                        />
                      )}
                    />
                  </div>
                </div>

                <fieldset
                  className={`px-3 mb-3 no-gutters form-group border bg-light rounded elevated`}
                >
                  <legend
                    className={` w-auto text-primary`}
                    style={{
                      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      fontWeight: 400,
                      fontSize: "0.82rem",
                      lineHeight: "1em",
                      letterSpacing: "0.00938em",
                    }}
                  >
                    [{trainingCohorts.length}] Cohort
                    {trainingCohorts.length > 1 ? "s" : ""}
                  </legend>

                  {trainingCohorts.map((cohort, cohortIndex) => (
                    <fieldset
                      key={cohortIndex}
                      className={`row mx-0 border rounded elevated mb-3`}
                    >
                      <legend
                        className={`px-3 w-auto text-dark`}
                        style={{
                          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                          fontWeight: 400,
                          fontSize: "0.8rem",
                          lineHeight: "1em",
                          letterSpacing: "0.00938em",
                        }}
                      >
                        Cohort #{cohortIndex + 1}
                      </legend>

                      <div className="col-3">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            readOnly={true}
                            onChange={() => {}}
                            minDate={new Date()}
                            label="Start date"
                            inputFormat="dd/MM/yyyy"
                            value={cohort.startDate || null}
                            renderInput={(params) => (
                              <TextField
                                name="startDate"
                                onKeyDown={(e) => e.preventDefault()}
                                size="small"
                                fullWidth
                                {...params}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                      <div className="col-3">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            readOnly={true}
                            onChange={() => {}}
                            label="End date"
                            inputFormat="dd/MM/yyyy"
                            value={cohort.endDate || null}
                            renderInput={(params) => (
                              <TextField
                                name="endDate"
                                onKeyDown={(e) => e.preventDefault()}
                                size="small"
                                fullWidth
                                {...params}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                      <div className="col-2">
                        <TextField
                          InputProps={{ readOnly: true }}
                          size="small"
                          className="mb-3"
                          required
                          type="number"
                          fullWidth
                          name="numOfHours"
                          label="Number of hours"
                          placeholder="Number of hours"
                          variant="outlined"
                          value={cohort.numOfHours || 0}
                        />
                      </div>
                      <div className="col-2">
                        <TextField
                          InputProps={{ readOnly: true }}
                          size="small"
                          className="mb-3"
                          required
                          type="number"
                          fullWidth
                          name="numberOfTrainees"
                          label="Number of trainees"
                          placeholder="Number of trainees"
                          variant="outlined"
                          value={cohort.numOfTrainees || 0}
                        />
                      </div>

                      <div className="col-2">
                        <NumberFormat
                          InputProps={{ readOnly: true }}
                          className="mb-3"
                          fullWidth
                          size="small"
                          name="budget"
                          variant="outlined"
                          label="Budget (RWF)"
                          placeholder="RWF 0"
                          prefix={"RWF "}
                          customInput={TextField}
                          value={cohort.budget || 0}
                          thousandSeparator={true}
                        />
                      </div>

                      <div className="col-12 px-3">
                        <fieldset
                          className={`px-3 pb-2 no-gutters form-group border  bg-light elevated rounded`}
                        >
                          <legend
                            className={` w-auto text-primary`}
                            style={{
                              fontFamily:
                                '"Roboto","Helvetica","Arial",sans-serif',
                              fontWeight: 400,
                              fontSize: "0.82rem",
                              lineHeight: "1em",
                              letterSpacing: "0.00938em",
                            }}
                          >
                            [{cohort.targetTrainees.length}] Target trainees
                            location
                            {cohort.targetTrainees.length > 1 ? "s" : ""}
                          </legend>

                          {cohort.targetTrainees.map(
                            (traineeTarget, traineeTargetIndex) => (
                              <fieldset
                                key={traineeTargetIndex}
                                className={`row border  bg-light mx-0 mb-2`}
                              >
                                <legend
                                  className={`col-12 px-3 w-auto text-dark`}
                                  style={{
                                    fontFamily:
                                      '"Roboto","Helvetica","Arial",sans-serif',
                                    fontWeight: 400,
                                    fontSize: "0.8rem",
                                    lineHeight: "1em",
                                    letterSpacing: "0.00938em",
                                  }}
                                >
                                  Location #{traineeTargetIndex + 1}
                                </legend>

                                <div className="col">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    size="small"
                                    className="mb-3"
                                    required
                                    type="text"
                                    fullWidth
                                    name="district"
                                    label="District"
                                    placeholder="District"
                                    variant="outlined"
                                    value={
                                      traineeTarget.district?.name || "All"
                                    }
                                    onChange={() => {}}
                                  />
                                </div>
                                <div className="col">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    size="small"
                                    className="mb-3"
                                    required
                                    type="text"
                                    fullWidth
                                    name="sector"
                                    label="Sector"
                                    placeholder="Sector"
                                    variant="outlined"
                                    value={traineeTarget.sector?.name || "All"}
                                  />
                                </div>
                                <div className="col">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    size="small"
                                    className="mb-3"
                                    required
                                    type="text"
                                    fullWidth
                                    name="school"
                                    label="School"
                                    placeholder="School"
                                    variant="outlined"
                                    value={
                                      traineeTarget.schoolScope?.school?.name ||
                                      "All"
                                    }
                                  />
                                </div>

                                <div className="col-12 ">
                                  <fieldset
                                    className={`px-4  form-group border  bg-white `}
                                  >
                                    <legend
                                      className={` w-auto text-primary`}
                                      style={{
                                        fontFamily:
                                          '"Roboto","Helvetica","Arial",sans-serif',
                                        fontWeight: 400,
                                        fontSize: "0.82rem",
                                        lineHeight: "1em",
                                        letterSpacing: "0.00938em",
                                      }}
                                    >
                                      [{traineeTarget.traineeCategories?.length}
                                      ] Trainees categor
                                      {traineeTarget.traineeCategories?.length >
                                      1
                                        ? "ies"
                                        : "y"}
                                    </legend>

                                    {traineeTarget.traineeCategories.map(
                                      (
                                        traineeCategory,
                                        traineeCategoryIndex,
                                      ) => (
                                        <fieldset
                                          key={traineeCategoryIndex}
                                          className={`row d-flex align-items-center mb-2 pb-2 bg-light border`}
                                        >
                                          <legend
                                            className={`col-12 w-auto text-dark `}
                                            style={{
                                              fontFamily:
                                                '"Roboto","Helvetica","Arial",sans-serif',
                                              fontWeight: 400,
                                              fontSize: "0.8rem",
                                              lineHeight: "1em",
                                              letterSpacing: "0.00938em",
                                            }}
                                          >
                                            Category #{traineeCategoryIndex + 1}
                                          </legend>

                                          <div className="col">
                                            <TextField
                                              InputProps={{ readOnly: true }}
                                              size="small"
                                              required
                                              type="text"
                                              fullWidth
                                              name="subCategory"
                                              label="Category"
                                              placeholder="Category"
                                              variant="standard"
                                              value={
                                                traineeCategory.subCategory
                                                  ?.name || "All"
                                              }
                                            />
                                          </div>

                                          {!!traineeCategory.category
                                            ?.hasSchoolLevel && (
                                            <div className="col">
                                              <TextField
                                                InputProps={{ readOnly: true }}
                                                size="small"
                                                required
                                                type="text"
                                                fullWidth
                                                name="schoolLevel"
                                                label="School Level"
                                                placeholder="School Level"
                                                variant="standard"
                                                value={
                                                  traineeCategory.subLevel
                                                    ?.name || "All"
                                                }
                                              />
                                            </div>
                                          )}

                                          {traineeCategory?.category?.id ===
                                            1 && (
                                            <div className="col">
                                              <TextField
                                                InputProps={{ readOnly: true }}
                                                size="small"
                                                required
                                                type="text"
                                                fullWidth
                                                name="subject"
                                                label="Subject"
                                                placeholder="Subject"
                                                variant="standard"
                                                value={
                                                  traineeCategory.subject
                                                    ?.name || "All"
                                                }
                                              />
                                            </div>
                                          )}

                                          <div className="col-3">
                                            <TextField
                                              InputProps={{ readOnly: true }}
                                              variant="standard"
                                              size="small"
                                              required
                                              type="number"
                                              fullWidth
                                              name="numberOfTrainees"
                                              label="Number of trainees"
                                              placeholder="Number of trainees"
                                              value={
                                                traineeCategory.numOfTrainees ||
                                                0
                                              }
                                            />
                                          </div>
                                        </fieldset>
                                      ),
                                    )}
                                  </fieldset>
                                </div>
                              </fieldset>
                            ),
                          )}
                        </fieldset>
                      </div>

                      <div className="col-12 px-3">
                        <fieldset
                          className={`px-3 mx-0 form-group border rounded elevated bg-white`}
                        >
                          <legend
                            className={` w-auto text-primary`}
                            style={{
                              fontFamily:
                                '"Roboto","Helvetica","Arial",sans-serif',
                              fontWeight: 400,
                              fontSize: "0.82rem",
                              lineHeight: "1em",
                              letterSpacing: "0.00938em",
                            }}
                          >
                            [{cohort.venues?.length}] Venue
                            {cohort.venues?.length > 1 ? "s" : ""}
                          </legend>

                          {cohort.venues?.map((cohortVenue, venueIndex) => (
                            <fieldset
                              key={venueIndex}
                              className={` mb-3 border rounded elevated px-3`}
                            >
                              <legend
                                className={`w-auto text-dark`}
                                style={{
                                  fontFamily:
                                    '"Roboto","Helvetica","Arial",sans-serif',
                                  fontWeight: 400,
                                  fontSize: "0.8rem",
                                  lineHeight: "1em",
                                  letterSpacing: "0.00938em",
                                }}
                              >
                                Venue #{venueIndex + 1}
                              </legend>

                              <div className="row">
                                <div className="col-2">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    size="small"
                                    required
                                    type="text"
                                    fullWidth
                                    name="venueType"
                                    label="Venue Type"
                                    placeholder="Venue Type"
                                    value={
                                      cohortVenue.venue?.venueType?.name ||
                                      "Other"
                                    }
                                  />
                                </div>
                                <div className="col-2">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    size="small"
                                    required
                                    type="text"
                                    fullWidth
                                    name="district"
                                    label="Location District"
                                    placeholder="Location District"
                                    value={
                                      cohortVenue.venue?.sector?.district
                                        ?.name || "All"
                                    }
                                  />
                                </div>

                                <div className="col-2">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    size="small"
                                    required
                                    type="text"
                                    fullWidth
                                    name="sector"
                                    label="Location Sector"
                                    placeholder="Location Sector"
                                    value={
                                      cohortVenue.venue?.sector?.name || "All"
                                    }
                                  />
                                </div>
                                <div className="col-4">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    size="small"
                                    required
                                    type="text"
                                    fullWidth
                                    name="venue"
                                    label="Venue"
                                    placeholder="Venue"
                                    value={cohortVenue.venue?.name || "All"}
                                  />
                                </div>

                                <div className="col-2">
                                  <TextField
                                    InputProps={{ readOnly: true }}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    type="number"
                                    name="venue-limit"
                                    label="Number of Trainees"
                                    placeholder="Number of Trainees"
                                    value={cohortVenue.numOfTrainees || 0}
                                  />
                                </div>
                              </div>

                              <fieldset className={`px-3 mt-2 form-group`}>
                                <legend
                                  className={` w-auto text-primary`}
                                  style={{
                                    fontFamily:
                                      '"Roboto","Helvetica","Arial",sans-serif',
                                    fontWeight: 400,
                                    fontSize: "0.82rem",
                                    lineHeight: "1em",
                                    letterSpacing: "0.00938em",
                                  }}
                                >
                                  Trainers
                                </legend>

                                {!!cohortVenue?.trainers?.length && (
                                  <table className="table table-striped">
                                    <thead>
                                      <tr
                                        style={{ backgroundColor: "#f0f2f5" }}
                                      >
                                        <th scope="col">#</th>
                                        <th scope="col">RegNo</th>
                                        <th scope="col">Names</th>
                                        <th scope="col">Category</th>
                                        <th scope="col">NID Number</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Phone</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {cohortVenue?.trainers?.map(
                                        (item, trainerIndex) => (
                                          <tr key={item.id}>
                                            <td className="text-left">
                                              {trainerIndex + 1}
                                            </td>
                                            <td className="text-left">
                                              <strong>{item.id}</strong>
                                            </td>
                                            <td className="text-left">
                                              {item.lastName} {item.firstName}
                                            </td>
                                            <td className="text-left">
                                              {item.categoryName}
                                            </td>
                                            <td className="text-left">
                                              {item.nidNumber}
                                            </td>
                                            <td className="text-left">
                                              {item.email}
                                            </td>
                                            <td className="text-left">
                                              {item.phoneNumber}
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                )}
                                {!cohortVenue?.trainers?.length && (
                                  <div className="container text-center jumbotron py-3">
                                    <p className="lead">Trainers not set</p>
                                  </div>
                                )}
                              </fieldset>

                              {/* <fieldset
                                className={`px-3 mt-3 no-gutters form-group border bg-light rounded elevated`}
                              >
                                <legend
                                  className={` w-auto text-primary`}
                                  style={{
                                    fontFamily:
                                      '"Roboto","Helvetica","Arial",sans-serif',
                                    fontWeight: 400,
                                    fontSize: "0.82rem",
                                    lineHeight: "1em",
                                    letterSpacing: "0.00938em",
                                  }}
                                >
                                  [{venueRooms.length}] Room
                                  {venueRooms.length > 1 ? "s" : ""}
                                  <IconButton
                                    color="primary"
                                    onClick={() => {
                                      const rooms = [...venueRooms];
                                      rooms.push(venueRoomsDefaults);
                                      setVenueRooms(rooms);
                                    }}
                                  >
                                    <Tooltip title="Add room" placement="top">
                                      <span className="material-icons">
                                        add
                                      </span>
                                    </Tooltip>
                                  </IconButton>
                                </legend>

                                {venueRooms.map((room, index) => (
                                  <div className="row " key={index}>
                                    <div className="col-3 mt-3">
                                      <TextField
                                        error={!!room.errors?.roomName}
                                        helperText={room.errors?.roomName || ""}
                                        size="small"
                                        required
                                        type="text"
                                        fullWidth
                                        name="roomName"
                                        label="Room name"
                                        placeholder="Room name"
                                        variant="outlined"
                                        value={room.roomName}
                                        onChange={(event) => {
                                          const rooms = [...venueRooms];

                                          rooms[index] = {
                                            ...room,
                                            roomName: event.target.value,

                                            errors: {
                                              ...room.errors,
                                              roomName: undefined,
                                            },
                                          };
                                          setVenueRooms(rooms);
                                        }}
                                      />
                                    </div>
                                    <div className="col-2 mt-3">
                                      <TextField
                                        error={!!room.errors?.numOfTrainees}
                                        helperText={
                                          room.errors?.numOfTrainees || ""
                                        }
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        type="number"
                                        name="venue-limit"
                                        label="Number of Trainees"
                                        placeholder="Number of Trainees"
                                        value={room.numOfTrainees || 0}
                                        onChange={(e) => {
                                          const rooms = [...venueRooms];

                                          let value = e.target.value || "";

                                          if (value.length > 1) {
                                            value = value.replace(/^0+/, "");
                                          }

                                          rooms[index] = {
                                            ...room,
                                            numOfTrainees: value,

                                            errors: {
                                              ...room.errors,
                                              numOfTrainees: undefined,
                                            },
                                          };
                                          setVenueRooms(rooms);
                                        }}
                                      />
                                     
                                    </div>
                                    <div className="col mt-3">
                                      <Autocomplete
                                        multiple
                                        size="small"
                                        // disableCloseOnSelect
                                        defaultValue={[]}
                                        value={room.trainers}
                                        options={cohortVenue?.trainers || []}
                                        isOptionEqualToValue={(option, value) =>
                                          option.id === value.id
                                        }
                                        getOptionLabel={(option) =>
                                          option.id +
                                          " - " +
                                          option.lastName +
                                          " " +
                                          option.firstName
                                        }
                                        renderOption={(
                                          props,
                                          option,
                                          { selected },
                                        ) => (
                                          <ListItem dense {...props}>
                                            <ListItemAvatar>
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                              />
                                            </ListItemAvatar>
                                            <ListItemText
                                              primary={
                                                option.id +
                                                " - " +
                                                option.lastName +
                                                " " +
                                                option.firstName
                                              }
                                            />
                                          </ListItem>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            error={!!room.errors.trainers}
                                            helperText={
                                              room.errors.trainers || ""
                                            }
                                            name="trainers"
                                            label="Select trainers"
                                            placeholder="Select trainers"
                                            inputProps={{
                                              ...params.inputProps,
                                            }}
                                          />
                                        )}
                                        onChange={(event, selected) => {
                                          const rooms = [...venueRooms];

                                          rooms[index] = {
                                            ...room,
                                            trainers: selected,

                                            errors: {
                                              ...room.errors,
                                              trainers: undefined,
                                            },
                                          };
                                          setVenueRooms(rooms);
                                        }}
                                      />
                                    </div>

                                    <div className="col-1 text-center">
                                      <IconButton
                                        disabled={venueRooms.length <= 1}
                                        color="error"
                                        onClick={() => {
                                          const rooms = [...venueRooms];
                                          rooms.splice(index, 1);
                                          setVenueRooms(rooms);
                                        }}
                                      >
                                        <Tooltip
                                          title="Remove room"
                                          placement="top"
                                        >
                                          <span className="material-icons">
                                            close
                                          </span>
                                        </Tooltip>
                                      </IconButton>
                                    </div>
                                  </div>
                                ))}

                                <div className="row">
                                  <div className="col-11 text-right my-3">
                                    <Button
                                      size="small"
                                      variant="contained"
                                      color="primary"
                                      onClick={() => onSave(cohortVenue)}
                                      type="button"
                                      className="px-5"
                                      disabled={loading || isLoading}
                                    >
                                      Save rooms
                                    </Button>
                                  </div>
                                </div>
                              </fieldset> */}

                              {/* <fieldset
                                className={`px-3 mt-2 form-group elevated`}
                              >
                                <legend
                                  className={` w-auto text-primary`}
                                  style={{
                                    fontFamily:
                                      '"Roboto","Helvetica","Arial",sans-serif',
                                    fontWeight: 400,
                                    fontSize: "0.82rem",
                                    lineHeight: "1em",
                                    letterSpacing: "0.00938em",
                                  }}
                                >
                                  ({cohortVenue?.trainees?.length || 0}/
                                  {cohortVenue.numOfTrainees}) Trainees
                                </legend>

                                {!!cohortVenue?.trainees?.length && (
                                  <table className="table table-striped">
                                    <thead>
                                      <tr
                                        style={{ backgroundColor: "#f0f2f5" }}
                                      >
                                        <th scope="col">#</th>
                                        <th scope="col">EmployeeId</th>
                                        <th scope="col">Names</th>
                                        <th scope="col">NID Number</th>
                                        <th scope="col">Position</th>
                                        <th scope="col">Role</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {cohortVenue?.trainees?.map(
                                        (item, trainerIndex) => (
                                          <tr key={item.id}>
                                            <td className="text-left">
                                              {trainerIndex + 1}
                                            </td>
                                            <td className="text-left">
                                              <strong>{item.employeeId}</strong>
                                            </td>
                                            <td className="text-left">
                                              {item.lastName} {item.firstName}
                                            </td>
                                            <td className="text-left">
                                              {item.nidNumber}
                                            </td>
                                            <td className="text-left">
                                              {item.positionName}
                                            </td>
                                            <td className="text-left">
                                              {item.role}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                )}
                                {!cohortVenue?.trainees?.length && (
                                  <div className="container text-center jumbotron py-3">
                                    <p className="lead">Trainees not set</p>
                                  </div>
                                )}
                              </fieldset> */}
                            </fieldset>
                          ))}
                        </fieldset>
                      </div>
                    </fieldset>
                  ))}
                </fieldset>

                <fieldset
                  className={`px-3 mt-3 no-gutters form-group border bg-light rounded elevated`}
                >
                  <legend
                    className={` w-auto text-primary`}
                    style={{
                      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      fontWeight: 400,
                      fontSize: "0.82rem",
                      lineHeight: "1em",
                      letterSpacing: "0.00938em",
                    }}
                  >
                    [{trainingMaterials.length}] Training material
                    {trainingMaterials.length > 1 ? "s" : ""}
                  </legend>

                  <List dense>
                    {trainingMaterials.map((material, index) => (
                      <ListItem key={index}>
                        <ListItemText
                          primary={material.description}
                          secondary={
                            <>
                              <a href={material.url} target="_blank">
                                {material.url}
                              </a>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </fieldset>

                <fieldset
                  className={`px-3 mt-3 no-gutters form-group border bg-light rounded elevated`}
                >
                  <legend
                    className={` w-auto text-primary`}
                    style={{
                      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                      fontWeight: 400,
                      fontSize: "0.82rem",
                      lineHeight: "1em",
                      letterSpacing: "0.00938em",
                    }}
                  >
                    Needs assessment
                  </legend>

                  <div className="row no-gutters">
                    <div className="col-12 mt-3">
                      <TextField
                        InputProps={{ readOnly: true }}
                        multiline
                        rows={3}
                        fullWidth
                        name="description"
                        label="Describe your needs assessment"
                        placeholder="Describe your needs assessment"
                        value={training.description}
                      />
                    </div>
                    <div className={`col-12 `}>
                      <small>Needs assessment document</small>
                      <Button
                        variant="outlined"
                        fullWidth
                        className="d-flex justify-content-start "
                        component="label"
                        startIcon={
                          <span className="material-icons">picture_as_pdf</span>
                        }
                        // size="small"
                        onClick={() => {
                          setUploadedDocument({
                            name: "Needs assessment document",
                            url: "\\" + training.needsAssessmentFilePath,
                          });
                          setShowUploadedDocument(true);
                        }}
                      >
                        Preview
                        {/* <input accept="application/pdf" type="file" /> */}
                      </Button>
                    </div>

                    <div className="col-12 mt-3 mb-2">
                      <span
                        className={`d-block mb-2 badge badge-${training.statusId === 1 ? "secondary" : [3, 4].includes(training.statusId) ? "danger" : "success"}`}
                      >
                        {training.statusName}
                      </span>
                    </div>
                  </div>
                </fieldset>
              </fieldset>
            </div>
          </div>
        </div>
        {showUploadedDocument && uploadedDocument && (
          <PreviewPdfUrl
            isBase64={true}
            showDocument={showUploadedDocument}
            setShowDocument={setShowUploadedDocument}
            document={{
              name: `${uploadedDocument?.name || ""}`,
              url: uploadedDocument?.url || "",
            }}
          />
        )}

        {!!approvals.statusId && (
          <ConfirmationDialog
            disabled={!approvals.statusComments && approvals.statusId === 3}
            confirmationDialog={!!approvals.statusId}
            message={
              <>
                <p className="mt-2">
                  Are you sure you want to{" "}
                  <strong
                    className={`text-${
                      approvals.statusId === 2 ? "success" : "danger"
                    }`}
                  >
                    {approvals.statusId === 2 ? "approve" : "reject"}
                  </strong>{" "}
                  this training?
                </p>
                {approvals.statusId === 3 && (
                  <TextField
                    multiline
                    rows={3}
                    autoFocus
                    fullWidth
                    type="text"
                    size="small"
                    name="reason"
                    label="Reason for decision"
                    variant="outlined"
                    placeholder="Reason for decision"
                    value={approvals.statusComments}
                    onChange={(e) => {
                      setApprovals({
                        ...approvals,
                        statusComments: e.target.value || "",
                      });
                    }}
                  />
                )}
              </>
            }
            setConfirmationDialog={(e) =>
              setApprovals({ statusId: "", statusComments: "" })
            }
            onYes={() => {
              approveTraining(
                {
                  id: training.id,
                  ...approvals,
                },
                (e) => {
                  setApprovals({ statusId: "", statusComments: "" });
                  onClose();
                },
              );
            }}
          />
        )}
      </DialogContent>

      <DialogActions className="d-flex py-2 justify-content-center">
        {training.statusId === 1 &&
          hasPermissions(["CPD_TRAININGS_APPROVE"]) && (
            <>
              <Button
                variant="contained"
                color="success"
                onClick={() =>
                  setApprovals({
                    statusId: 2,
                    statusComments: "",
                  })
                }
                type="button"
                className="px-4"
                disabled={loading}
              >
                Approve
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() =>
                  setApprovals({
                    statusId: 3,
                    statusComments: "",
                  })
                }
                type="button"
                className="px-4"
                disabled={loading}
              >
                Reject
              </Button>
            </>
          )}
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = ({ user, loading }) => {
  return {
    user,
    loading,
  };
};

export default connect(mapStateToProps, {
  approveTraining,
  getSchoolSubLevelSubjects,
})(PreviewTrainingDialog);
